<template>
<div class="commission-rule-group">
  <div class="title">{{$t('Commission_rebate_rules')}}</div>
  <div
    v-for="(item,index) in SelfRuleData"
    :key="index"
    class="group-box"
  >
    <div class="header">{{item.mt4GroupNamme}}</div>
    <div class="group-content">
      <div
        v-for="(itemInner,i) in item.symbolGroup"
        :key="i"
        class="input-outer pr"
      >
        <span class="input-label">{{itemInner.name}}</span>
        <span v-if="isReadonly || itemInner.max == -1">
           {{getReadonlyText(itemInner)}}
           <span>{{getSuffix(itemInner.suffix,itemInner)}}</span>
        </span>
        <el-input
          v-else
          maxLength="6"
          :disabled="isDisabeld"
          :placeholder="getPlaceholder(itemInner.max,index,i)"
          v-model="itemInner.value"
          @blur="blurHandle(itemInner)"
          :class="validateClass(itemInner,index,i)"
        >
          <span slot="suffix" class="suffix-self">{{getSuffix(itemInner.suffix,itemInner)}}</span>
        </el-input>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { getRuleValidateFlag,getHandleRuleData } from "@/utils/common";

export default {
  name: "commissionRuleGroup",
  props: {
    ruleData: {
      type: Array,
      default(){
        // return [];
        return [
          /*{
            accountNamme: 'STD',
            symbolGroup: [
              {
                name: 'Forex',
                value: 5,
                max: 5,
                suffix: 1,
                tips: '≤5'
              },
              {
                name: 'GOLD',
                value: 3,
                max: 3,
                suffix: 3,
                tips: '≤3'
              },
              {
                name: 'SUVKER',
                value: 2,
                max: 2,
                suffix: 1,
                tips: '≤2'
              },
              {
                name: 'Oil',
                value: 0.2,
                max: 0.2,
                suffix: 3,
                tips: '≤0.2'
              },
              {
                name: 'INDEX',
                value: 1,
                max: 1,
                suffix: 1,
                tips: '≤1'
              }
            ]
          },*/
        ];
      }
    },
    fatherRuleData:{
      type: Array,
      default(){
        return []
      }
    },
    isDisabeld:{
      type: Boolean,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      SelfRuleData: JSON.parse(JSON.stringify(this.ruleData)),
    }
  },
  watch:{
    ruleData(newVal){
      this.SelfRuleData = JSON.parse(JSON.stringify(newVal.slice(0)));
    },
  },
  methods: {
    clearCom(dataList){
      for (let i = 0; i < dataList.length; i++) {
        for (let j = 0; j < dataList[i].symbolGroup.length; j++) {
          dataList[i].symbolGroup[j].value = '';
        }
      }
    },
    getSuffix(suffix,colItem){
      if(colItem.max == -1){
        return '';
      }
      if(suffix === 1){
        return '$' + '/lot';
      }else if(suffix === 3){
        return 'pips' + '/lot'
      }if(suffix === 4){
        return '%';
      }
    },
    getReadonlyText(item){
      if(item.max == -1){
        return '/'
      }
      return `${item.value}`;
    },
    getPlaceholder(max,index,i){
      // max value 都是-1就显示/
      if(max == -1){
        // console.log(max);
        return '/';
      }
      // 修改代理的佣金规则不需要显示<=
      if(this.fatherRuleData.length){
        // console.log(max);

        return this.fatherRuleData[index].symbolGroup[i].value;
      }else {
        return '≤' + max;
      }
    },
    blurHandle(colItem){
      if(!this.fatherRuleData.length){
        if(colItem.value > colItem.max){
          this.$message({
            type: 'warning',
            message: `${this.$t('The_highest_can_be_set')}${colItem.max}`
          });
          return;
        }
      }
    },
    validateClass(colItem,index,i){
      if(!this.fatherRuleData.length){
        if(colItem.value > colItem.max){
          return 'nopass';
        }else {
          return '';
        }
      }else {
        if(colItem.value > this.fatherRuleData[index].symbolGroup[i].value){
          return 'nopass';
        }else {
          return '';
        }
      }
    },
    validateTable(){
      // 现在SelfRuleData没有数据所以报错了,
      let pass = getRuleValidateFlag(this.SelfRuleData,this.fatherRuleData,this);
      if(!pass){
        return;
      }else {
        let copySelfRuleData = getHandleRuleData(this.SelfRuleData);

        this.$emit('submit',copySelfRuleData);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.commission-rule-group {
  .title {
    margin-bottom: 10px;
  }
  .group-box {
    border: 1px solid #EBE9F1;
    border-radius: 5px;
    margin-bottom: 10px;
    .header {
      background-color: #FAFAFA;
      font-weight: bold;
      color: #5E5873;
      padding-left: 10px;
      height: 36px;
      line-height: 36px;
    }
    .group-content {
      padding: 0 15px;
      padding-bottom: 15px;
      padding-top: 15px;
    }
    .input-outer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .input-label {
        width: 100px;
        font-size: 12px;
      }
      .suffix-self {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        word-break: normal;
      }
    }
  }

}
</style>
<style lang="scss">
.commission-rule-group {
  .nopass {
    .el-input__inner {
      color: red;
    }
  }
}
</style>
